(function($) {
	$(document).on('ready.scrollto', function() {
		$('[data-scrollto]').on('click.scrollto', function(event) {
			var anchor = $(this).attr('href');
			if ($(anchor).length) {
				event.preventDefault();
				$('html, body').animate({ scrollTop: $(anchor).offset().top });
			}
		});
        const scrollToTopButton = document.querySelector('.ct-scroll-to-top');
        if (scrollToTopButton) {
            document.addEventListener('scroll', checkScrollHeight);
            scrollToTopButton.addEventListener('click', scrollToTop);

            function scrollToTop(event) {
                event.preventDefault();
                $('html, body').animate({ scrollTop: 0 });
            }

            function checkScrollHeight() {
                if (!scrollToTopButton) {
                    return;
                }
                const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
                const ratio = 0.5;

                if ((document.documentElement.scrollTop / scrollableHeight) > ratio) {
                    scrollToTopButton.style.display = "block";
                } else {
                    scrollToTopButton.style.display = "none";
                }
            }
        }
	});
}(jQuery));
